import React from "react";
import "./ContactPage.css";
import ContactForm from "../components/ContactForm/ContactForm";

const ContactPage = () => {
    return (
        <div className="contact-page">
            {/* Bandeau d'introduction */}
            <section className="contact-intro">
                <h1>Contactez-nous</h1>
                <p>Vous avez des questions ou souhaitez en savoir plus ? N'hésitez pas à nous écrire !</p>
            </section>

            {/* Formulaire de contact */}
            <ContactForm />


            {/* Informations de contact */}
            <section className="contact-info-section">
                <h2>Nos Informations</h2>
                <div className="contact-info">
                    <p><strong>Adresse :</strong> 17 Route du Chêne Vert, Thouaré-sur-Loire, 44470</p>
                    <p><strong>Email :</strong> <a
                        href="mailto:nantesdoulonfutsal@gmail.com">nantesdoulonfutsal@gmail.com</a></p>
                    <p><strong>Téléphone :</strong> +33 6 64 27 88 75</p>
                </div>
            </section>

            {/* Carte Google Maps */}
            <section className="contact-map-section">
                <h3>Notre Localisation</h3>
                <iframe
                    src="https://maps.google.com/maps?q=17+Route+du+Chêne+Vert,+Thouaré-sur-Loire,+France&t=&z=13&ie=UTF8&iwloc=&output=embed"
                    width="100%"
                    height="400px"
                    frameBorder="0"
                    allowFullScreen
                ></iframe>

            </section>

        </div>
    );
};

export default ContactPage;
